// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryGalleryStyles } from "@conklin/App/Widgets/Catergory/CategoryGallery";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

categoryGalleryStyles.wrapper = {
    css: css`
        margin-top: 32px;
        padding: 16px;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        background-color: ${color("common.ui8")};
        column-gap: 16px;
        row-gap: 24px;
        display: flex;
        justify-content:center;
        align-items: start;
        justify-items: center;
        flex-wrap:wrap;
        ${xScreen("lte", "md")} {
            column-gap: 36px;
            padding: 18px;
        }
        ${xScreen("lte", "sm")} {
            column-gap: 16px;
        }
    `,
};

categoryGalleryStyles.categoryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 148px;
    `,
};

categoryGalleryStyles.imageCategoryWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        min-width: 100%;
        height: 148px;
        ${xScreen("lte", "sm")} {
            height: 156px;
        }
    `,
};

categoryGalleryStyles.categoryName = {
    size: 16,
    weight: fontConfig.weight.bold,
    color: "text.link",
    css: css`
        line-height: 20px;
        text-align: center;
        ${ellipsis(2)};
        margin-top: 8px;
        &:hover {
            color: ${color("common.ui10")};
        }
    `,
};

categoryGalleryStyles.categoryImage = {
    css: css`
        width: 100%;
        height: 100%;
        padding: 12px;
    `,
};
